import React from 'react';
import { BatteryChargingIcon, CheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="final-title" data-id="element-60" data-mp="15dltuxi2kusm">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-61" data-mp="1jclmshcm7vul">
        <h2 id="final-title" className="text-balance font-display text-4xl font-bold uppercase tracking-tight text-foreground sm:text-5xl" data-id="element-62" data-mp="1jb25cnf83er8">
          <span className="inline-flex items-center gap-2" data-id="element-63" data-mp="1t37tfm2ctc15">
            <BatteryChargingIcon className="h-8 w-8 shrink-0 text-accent" aria-hidden="true" data-id="element-64" data-mp="1t4rb9h3nrv51" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-accent sm:text-2xl" data-id="element-65" data-mp="22339o5arnx81">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-66" data-mp="1x2oyiedvc75s">
          Created by battery and energy storage technical specialists, for professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-67" data-mp="s6s3ac7x8dh7">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-68" data-mp="124g6zrni8vbi">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-69" data-mp="1b3jst3e23otp">
              <CheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-70" data-mp="1b1qm5o3g14lp" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}